import type {Mute} from '../../../services/rest'

export const getAssignmentName = (
  mute: Mute | null | undefined,
  isMutedByCurrentUser: boolean,
): string => {
  const assignment = mute?.assignment
  const userName = assignment?.user?.name ?? assignment?.user?.username ?? ''
  return isMutedByCurrentUser ? 'you' : userName
}
